import React, { useState, useCallback, useEffect } from "react";
import { Image } from '@fluentui/react';
import {AppMenu} from "./AppMenu";


interface DataManagementProps {}

interface DataManagementState {}

const DataManagement: React.FC<DataManagementProps> = ({}) => {           
    const [pageState, setPageState] = useState<DataManagementState>(() => {});

    return(
        <>
                    <div style={{width: "100%", textAlign: "left"}}>
                        <AppMenu/>
                    </div>
                    <div key={'DM1'} style={{ 
                    flex: '1 1 calc(100% - 40px)',
                    minWidth: '250px',
                    height: '550px',
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    overflow: 'hidden'
                  }}>
                    <div style={{ 
                      padding: '15px', 
                      borderBottom: '0px solid #e1e1e1',
                      background: '#ffffff',
                      fontWeight: 600,
                      color: '#323130'
                    }}>
                      Data Management
                    </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                       <div className="card-grey">         
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{ gap: '8px', letterSpacing: '0.02em', fontSize: '0.95rem' }}>At every moment, global businesses generate vast amounts of data. This can be related to anything, for example people, processes, machines, R&D, quality, regulatory, environment etc. Collecting and utilizing these data for new value generations is more challenging than ever. This can be for working capital planning for a manufacturing organization or drug discovery for a life science firm. As the technology landscape evolves, it adds more complexity in terms of resources, management, expenses and returns. We help business to achieve their next competitive advantage out of data that fit into the budget and adhering to the best security, processing and storage practices.</div>
                                <Image src="datamanagement.png" alt="Data Management" style={{ width: '450px', height: '350px', objectFit: 'scale-down' }} />
                             </div>
                      </div>
                    </div>
                  </div>
                </>
    );
}

export default DataManagement; 
